import React, { FC } from 'react';
import styled from 'styled-components';
import { map } from 'lodash';

import { BaseDebugContainer } from './LookupDebuggingStyles';
import ExpandCollapsePayload from './ExpandCollapsePayload';
import { Request } from 'src/actions/integrations/lookupAdapterDebugging/lookupDebuggerBasicResource';

type RequestContainerProps = {
  request: Request;
  requestType: string;
};

const RequestContainer: FC<RequestContainerProps> = ({ requestType, request }) => {
  const queryParams = request?.payload?.query;
  const getParameters = () => {
    return map(queryParams, (val, key) => {
      return (
        <QueryParam key={`searchAttr-${key}`}>
          {key}={val}
        </QueryParam>
      );
    });
  };

  const parameters = getParameters();

  return (
    <>
      <DebugStepContainer>
        <b>
          A{requestType === 'Autolinking' && 'n'} {requestType} request with query parameters{' '}
        </b>
        {parameters}
        <b> was made to your lookup adapter.</b>
        <ExpandCollapsePayload payload={request?.payload} lookupType={requestType} payloadType="request" />
      </DebugStepContainer>
    </>
  );
};

const DebugStepContainer = styled.div`
  ${BaseDebugContainer}
  line-height: 1.5em;
  margin: 12 0px;
  width: 100%;
`;

const QueryParam = styled.span`
  background: ${p => p.theme.colors.gray100};
  border: 1px solid ${p => p.theme.colors.gray300};
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0 4px;
  margin: 0 2px;
`;

export default RequestContainer;
